<template lang="pug">
  section
    b-container
      h1 Art
      b-form-group(label="SHOW")
            b-form-checkbox-group(:options="statusOptions", v-model="filter.status", switches, @input="getArt(true)")
      content-loader(:height="7", v-if="alert.loading")
      b-card.table-card(v-else-if="art && art.length > 0")
        p(v-if='art.length < 1') No art
        b-table(v-else="", hover, :items="art", :fields="fields", @row-clicked="openRow", sort-icon-left, sort-by="status_id", :sort-desc="false", responsive, borderless)
          template(v-slot:cell(compTitle)="row")
                    h4.m-0.mr-1.d-inline {{ row.item.title }}
                    p.m-0 {{ `${row.item.artist}` }}
          template(v-slot:cell(compPrice)="row") {{ formatRands(row.item.price) }}
          template(v-slot:cell(compSortIndex)="row")
            b-form-rating.stars(@click.native.stop='', stars="3", v-model="row.item.sort_index", no-border, @change="setSortIndex(row.item)")
          //- template(v-slot:cell(compStatus)="row")
            b-badge(:variant="row.item.status === 'pending' ? 'dark' : 'light'") {{ row.item.status }}
      //b-pagination.mt-2(v-model="currentPage", :total-rows="totalRows", :per-page="10", size="sm", align="right")
      p(v-else="") No art available
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import router from '@/router';
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';
import Vue from 'vue';

export default {
  name: 'Artist',
  components: {
    ContentLoader,
  },
  mixins: [standardMix],
  data() {
    return {
      art: [],
      currentPage: 1,
      polling: null,
      lastUpdate: '',
      fields: [
        { key: 'compTitle', label: 'Piece', sortable: true },
        // { key: 'artist', label: 'Artist', sortable: true },
        { key: 'compPrice', label: 'Price' },
        { key: 'compSortIndex', label: 'Index', sortable: true },
        // { key: 'compStatus', label: 'Status' },
        // { key: 'actions', label: '' },
      ],
      statusOptions: ['pending', 'available', 'sold', 'rented'],
      filter: {
        status: ['pending'],
      },
    };
  },
  computed: {
    totalRows() {
      return this.art.length;
    },
    artPending() {
      return this.art.filter(item => item.status === 'pending');
    },
  },
  methods: {
    openRow(row) {
      router.push({ name: 'Piece', params: { pieceId: row.id } });
    },
    async getArt() {
      this.loading();
      this.art = await apiService.getArt(this.filter);
      this.clear();
    },
    async setSortIndex(piece) {
      try {
        await apiService.setSortIndex(piece.id, piece.sort_index);
        const newPiece = { ...piece };
        newPiece.sort_index = piece.sort_index;
        const index = this.art.findIndex(item => item.id === piece.id);
        Vue.set(this.art, index, newPiece);
      } catch (error) {
        this.error('Could not update sort index');
      }
    },
  },
  async created() {
    await this.getArt();
  },
};
</script>

<style lang="scss" scoped>
.stars {

}
  .table-responsive {
    margin-bottom: 0;
  }

  .card-body {
    padding: 0;
  }

  .logo {
    width: 200px;
    max-height: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Art.vue